
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire8565"];
var parcelRegister = parcelRequire.register;
parcelRegister("5duVz", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $9767334c903e2700$export$36aff1fbb4f5dfc6);

var $2T9xh = parcelRequire("2T9xh");

var $aOzEm = parcelRequire("aOzEm");

var $bq2Ba = parcelRequire("bq2Ba");

var $8Rfza = parcelRequire("8Rfza");

var $2aiPz = parcelRequire("2aiPz");

var $sdOpr = parcelRequire("sdOpr");
const $9767334c903e2700$var$scopes = [
    "activate:pipeline",
    "activate:connection",
    "read:account",
    "read:billing",
    "read:connection",
    "read:pipeline",
    "read:stream",
    "write:account",
    "write:billing",
    "write:connection",
    "write:pipeline",
    "write:stream",
    "write:preview",
    "profile",
    "email",
    "openid"
];
function $9767334c903e2700$export$36aff1fbb4f5dfc6(AppPromise) {
    const App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).lazy(()=>AppPromise);
    const root = (0, $bq2Ba.createRoot)(document.getElementById("app"));
    root.render(/*#__PURE__*/ (0, $2T9xh.jsx)((0, $8Rfza.Auth0Provider), {
        domain: (0, $2aiPz.config).DECODABLE_AUTH0_DOMAIN,
        clientId: (0, $2aiPz.config).DECODABLE_AUTH0_SPA_CLIENT_ID,
        authorizationParams: {
            audience: (0, $2aiPz.config).DECODABLE_AUTH0_API_AUDIENCE,
            redirect_uri: `${window.location.origin}/-/callback/auth`,
            scope: $9767334c903e2700$var$scopes.join(" ")
        },
        onRedirectCallback: (appState)=>{
            window.location.replace(appState.target || appState.returnTo);
        },
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
        children: /*#__PURE__*/ (0, $2T9xh.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aOzEm))).Suspense, {
            fallback: /*#__PURE__*/ (0, $2T9xh.jsx)((0, $sdOpr.LazyLoadingFallback), {}),
            children: /*#__PURE__*/ (0, $2T9xh.jsx)(App, {})
        })
    }));
}

});
parcelRegister("bq2Ba", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $850423704c0fc6fc$export$882461b6382ed46c, (v) => $850423704c0fc6fc$export$882461b6382ed46c = v);
var $850423704c0fc6fc$export$882461b6382ed46c;
var $850423704c0fc6fc$export$757ceba2d55c277e;
"use strict";

var $lOkAX = parcelRequire("lOkAX");
var $850423704c0fc6fc$var$i;
$850423704c0fc6fc$export$882461b6382ed46c = $lOkAX.createRoot;
$850423704c0fc6fc$export$757ceba2d55c277e = $lOkAX.hydrateRoot;

});



//# sourceMappingURL=bootstrap.e0e4415a.js.map
